export const Ivf = 'ivf'
export const Icsi = 'icsi'